/* ProfilePage auto-generated by npm run generator */
import { Button, CircularProgress, FormHelperText, makeStyles, TextField, Theme, Typography } from "@material-ui/core"
import { firebasePhoneFormat, toPrettyPhoneNum } from "@qlarity/common"
import { useLoading } from "hooks/useLoading"
import { observer } from "mobx-react"
import React from "react"
import ReactInputMask from "react-input-mask"
import Store from "store/Store"

interface ProfilePageProps {}

const useStyles = makeStyles((theme: Theme) => ({
    profilePagePage: {
        display: "grid",
        gridGap: theme.spacing(4),
        maxWidth: 600,
    },
    buttons: {
        width: "100%",
        display: "grid",
        gridGap: theme.spacing(10),
        gridAutoFlow: "column",
        justifyContent: "center",
        gridAutoColumns: "1fr",
        justifyItems: "center",
        direction: "rtl",
    },
}))

const ProfilePage: React.FC<ProfilePageProps> = (props) => {
    const classes = useStyles()
    const { loading, error, action } = useLoading()

    const [displayName, setDisplayName] = React.useState(Store.auth.authUser?.displayName)
    const [phoneNumber, setPhoneNumber] = React.useState(toPrettyPhoneNum(Store.auth.portalUser?.appPhoneNumber ?? ""))

    const saveChanges = async () => {
        if (Store.auth.authUser?.displayName !== displayName && displayName) {
            await Store.auth.updateDisplayName(displayName)
        }
        if (Store.auth.portalUser?.appPhoneNumber !== phoneNumber && phoneNumber != null) {
            await Store.auth.updateClinicianAppPhoneNumber(phoneNumber)
        }
    }

    const cancel = () => {
        setDisplayName(Store.auth.authUser?.displayName)
        setPhoneNumber(toPrettyPhoneNum(Store.auth.portalUser?.appPhoneNumber ?? ""))
    }

    const authedUser = Store.auth.authUser
    React.useEffect(() => {
        setDisplayName(authedUser?.displayName)
    }, [authedUser])

    const portalUser = Store.auth.portalUser
    React.useEffect(() => {
        if (portalUser?.appPhoneNumber) {
            setPhoneNumber(toPrettyPhoneNum(portalUser?.appPhoneNumber))
        }
    }, [portalUser])
    console.log({ auth: Store.auth.portalUser?.appPhoneNumber, raw: firebasePhoneFormat(phoneNumber), phone: phoneNumber })
    return (
        <div className={classes.profilePagePage}>
            <Typography variant="h5">Edit Profile</Typography>

            <TextField label="Display Name" value={displayName} onChange={(e) => setDisplayName(e.target.value)} />

            <Typography>
                If you would like access to an unlocked version of the mobile application that your clients will use, please enter your mobile phone number
                below.
            </Typography>
            <ReactInputMask mask="(999) 999 9999" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}>
                {() => <TextField label="Phone Number (Optional)" type="tel" />}
            </ReactInputMask>

            <FormHelperText error>{error}</FormHelperText>

            <div className={classes.buttons}>
                <Button
                    disabled={
                        (displayName === Store.auth.authUser?.displayName &&
                            (Store.auth.portalUser?.appPhoneNumber ?? "") === firebasePhoneFormat(phoneNumber)) ||
                        !displayName ||
                        loading
                    }
                    onClick={() => action(saveChanges)}
                >
                    {loading ? <CircularProgress size="1rem" /> : "Save Changes"}
                </Button>
                <Button color="secondary" onClick={cancel}>
                    Cancel
                </Button>
            </div>
        </div>
    )
}

export default observer(ProfilePage)
